<template>
  <a
    :download="filename"
    style="cursor: pointer"
    class="text-decoration-none"
    @click="clickEvent"
  >
    <slot :loading />
  </a>
</template>

<script lang="ts">

import {ApiService} from "../../utils/api.service";

export default {
    props: {
        url: {type: String, required: true},
        filename: {type: String, required: false, default : "" },
    },
    data () {
        return {
            dataUrl: null,
            loading: false,
        }
    },
    methods: {
        clickEvent() {
            this.loading = true
            const api= this.$api as ApiService;
            api.triggerDownload(this.url, this.filename).then( res => {
              this.loading = false
            }).catch( (err) => {
                this.$showToaster({ text: err, color: 'error', icon: 'mdi-alert-circle', timer: 8 })
                this.loading = false
            })
        },
    }

}

</script>
